import { CheerzApiPartnership } from "@Types/api/partnership";
import { Partnership } from "@Types/partnership";

export const convertPartnershipFromApiToContent = (
  jsonContent: CheerzApiPartnership
): Partnership => {
  return {
    campaignType: jsonContent.campaign_type,
    cheerzBrandingText: jsonContent.cheerz_branding_text,
    codeExpirationDate: jsonContent.code_expiration_date,
    codeValue: jsonContent.code_value,
    ctaLink: jsonContent.cta_link,
    instructionsText: jsonContent.instructions_text,
    locale: jsonContent.locale,
    mainImageReducedUrl: jsonContent.main_image_reduced_url,
    mainImageUrl: jsonContent.main_image_url,
    offerButtonText: jsonContent.offer_button_text,
    partnerLogoUrl: jsonContent.partner_logo_url,
    partnershipConditions: jsonContent.partnership_conditions,
    partnershipText: jsonContent.partnership_text,
    referenced: jsonContent.referenced,
    registeredOnly: jsonContent.registered_only,
    tag: jsonContent.tag,
    title: jsonContent.title,
    userLogged: jsonContent.user_logged,
  };
};
